import {
  Box,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material'
import DateRangeIcon from '@mui/icons-material/DateRange'
import React, { useState, useEffect } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './useStyles'
import AddIcon from '@mui/icons-material/Add'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { getAllApplicationAppModule } from '../../../../app/services/eAuthz/getAllApplicationAppModuleEAuthz'
import { EnableApplicationInstanceAppModule } from '../../../../app/services/eAuthz/EnableApplicationInstanceAppModule'
import { useNavigate, useParams } from 'react-router-dom'
import { updateApplicationInstanceAppModule } from '../../../../app/services/eAuthz/updateApplicationInstanceAppModuleEAuthz'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../../redux/actions/app'
import { useDispatch } from 'react-redux'
import { logEvent } from '../../../../utils/LogEvents'
import { es } from 'date-fns/locale'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  height: 450,
  bgcolor: 'white',
  p: 3,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export const AddModuleModal = ({ modules }) => {
  const classes = useStyles()
  const { id } = useParams()
  const [showCircularProgress, setShowCircularProgress] = useState(false)
  const [openModal, setopenModal] = useState(false)
  const [valueRadioButtons, setvalueRadioButtons] = useState(null)
  const [allmodules, setallmodules] = useState([])
  const [isError, setIsError] = useState(false)

  const handleOpen = () => {
    setopenModal(true)
  }
  const handleChangeRadioButton = (e) => {
    setvalueRadioButtons(e.target.value)
  }
  const [selectedDate, setSelectedDate] = useState(null)

  const handleDateChange = (date) => {
    if (date < new Date()) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar(
          'La fecha de seleccionada tiene que ser posterior a hoy'
        )
      )
    } else {
      setSelectedDate(date)
    }
  }

  const getModulesByEnabled = (appModules) => {
    const today = new Date()

    const modulesFinishDateDisabled = modules.filter(
      (elem) => elem.finishDate && new Date(elem.finishDate) < today
    )
    const modulesNotEnabled = appModules.filter(
      (elem) => !modules.find((item) => item.appModule === elem.appModule)
    )
    return modulesNotEnabled.concat(modulesFinishDateDisabled)
  }


  const getModulesByApp = async () => {
    try {
      const resp = await getAllApplicationAppModule()
      if (resp.data?.data?.appModules) {
        setallmodules(getModulesByEnabled(resp.data?.data?.appModules))
      }
    } catch (error) {}
  }



  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleAddModule = async () => {
    setShowCircularProgress(true)
    try {
      const startDate = new Date().toISOString()
      if (!selectedDate) {
        const body = {
          applicationInstanceId: id,
          appModuleCode: valueRadioButtons,
          startDate,
          finishDate: selectedDate ? selectedDate.toISOString() : null,
          subscriptionTypeRefCode: null
        }
        await handleModuleRequest(body)
      } else if (selectedDate < new Date()) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'La fecha de finalización debe ser posterior a la fecha de inicio'
          )
        )
      } else {
        const body = {
          applicationInstanceId: id,
          appModuleCode: valueRadioButtons,
          startDate,
          finishDate: selectedDate ? selectedDate.toISOString() : null,
          subscriptionTypeRefCode: null
        }
        await handleModuleRequest(body)
      }
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Habilitación exitosa'))

      setTimeout(() => {
        navigate(0)
      }, 1000)
    } catch (error) {
      setIsError(true)

      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar('Ocurrió un error en un servicio de: eAuthzAPI')
      )
    }
    setShowCircularProgress(false)
  }

  const handleModuleRequest = async (body) => {
    if (!modules.find((item) => item.appModule === valueRadioButtons)) {
      const response = await EnableApplicationInstanceAppModule(body)
      logEvent('CGI - EnableApplicationInstanceAppModule', {
        body: {
          body
        },
        response: response
      })
    } else {
      const response = await updateApplicationInstanceAppModule(body)
      logEvent('CGI - updateApplicationInstanceAppModule', {
        body: body,
        response: response
      })
    }
  }

  useEffect(async () => {
    await getModulesByApp()
  }, [])

  return (
    <>
      <button className={classes.buttonAddModule} onClick={handleOpen}>
        <AddIcon style={{ color: '#028B7E' }} />
        <Typography className={classes.typographyButton}>
          Nuevo modulo
        </Typography>
      </button>
      <Modal open={openModal} onClose={() => setopenModal(false)}>
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CloseIcon
              sx={{
                fontSize: 'medium',
                color: '#263057',
                cursor: 'pointer'
              }}
              onClick={() => setopenModal(false)}
            />
          </div>
          <Typography sx={{ color: '#263057', fontSize: '1.3em' }}>
            Habilitar un nuevo módulo
          </Typography>
          <Typography
            style={{ color: '#263057', marginTop: 10, marginLeft: 5 }}
          >
            Seleccione el módulo:
          </Typography>
          <div
            style={{
              minHeight: 150,
              maxHeight: 250,
              marginTop: 5,
              marginLeft: 5,
              overflowY: 'auto'
            }}
          >
            <FormControl>
              <RadioGroup
                value={valueRadioButtons || ''}
                onChange={handleChangeRadioButton}
              >
                {allmodules && allmodules.length > 0
                  ? (
                      allmodules.map((item) => (
                    <FormControlLabel
                      key={item.appModuleId}
                      value={item.appModule}
                      control={
                        <Radio size="small" style={{ color: '#263057' }} />
                      }
                      label={
                        <Typography
                          style={{ color: '#263057', fontSize: '0.9rem' }}
                        >
                          {item.appModuleName}
                        </Typography>
                      }
                      style={{ height: 25 }}
                    />
                      ))
                    )
                  : (
                  <Typography>No se encontró módulos para habilitar</Typography>
                    )}
              </RadioGroup>
            </FormControl>
          </div>

          {valueRadioButtons && (
            <>
              <Typography
                style={{
                  color: '#263057',
                  marginTop: 10,
                  marginLeft: 5,
                  marginBottom: 5
                }}
              >
                Seleccione la fecha de vencimiento:
              </Typography>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '1px 1px 1px 1px'
                }}
              >
                <DateRangeIcon sx={{ color: '#263057', fontSize: '2em' }} />
                <div style={{ width: '80%', paddingLeft: 5 }}>
                  <div style={{ display: 'flex' }}>
                    <Typography sx={{ color: '#263057', width: '20%' }}>
                      Hasta:
                    </Typography>
                    <div
                      style={{
                        width: '70%'
                      }}
                    >
                      <DatePicker
                        id="date"
                        selected={selectedDate}
                        onChange={handleDateChange}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="dd/mm/aaaa"
                        showYearDropdown
                        scrollableYearDropdown
                        locale={es}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <Box className={classes.buttons} style={{ marginLeft: '50%' }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              isError={isError}
              handleAddModule={handleAddModule}
            />

            <ButtonClose handleClose={() => setopenModal(false)} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm ({ showCircularProgress, isError, handleAddModule }) {
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)

  const handleButtonClick = async () => {
    if (!isProgressComplete && !showCircularProgress && !isError) {
      try {
        await handleAddModule()
        setProgressComplete(true)
      } catch (error) {}
    }
  }

  useEffect(() => {
    if (isError) {
      setProgressComplete(false)
    }
  }, [isError])

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className={`${classes.confirmButton} ${
          isProgressComplete ? classes.disabledButton : ''
        }`}
        disabled={isProgressComplete || showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress
          ? (
          <CircularProgress size="1.5rem" color="inherit" />
            )
          : (
          <Typography
            onClick={handleAddModule}
            className={classes.confirmButtonTypography}
            variant="contained"
          >
            Habilitar
          </Typography>
            )}
      </button>
    </div>
  )
}

function ButtonClose ({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
